// Shared shell for the per-page bulk-ops action bar. Each page used
// to render a near-identical Stack with selected-count, Clear button,
// flex spacer, action buttons, and an inline progress bar. This
// component owns the shell; callers pass their per-page action
// buttons as `actions`.
//
// Visibility is the caller's job (threshold + force-show gating
// happens upstream); this component just renders when handed
// non-zero `selectedCount`.
import React from 'react';
import { Box, Stack, Typography, Button, LinearProgress } from '@mui/material';

export default function BulkActionBar({
  selectedCount,
  busy,
  progress,
  onClear,
  actions,
}) {
  if (!selectedCount) return null;
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        mb: 2, p: 1.5, alignItems: 'center', flexWrap: 'wrap',
        borderRadius: 1, border: '1px solid', borderColor: 'primary.main',
        bgcolor: 'action.selected',
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        {selectedCount} selected
      </Typography>
      <Button size="small" onClick={onClear} disabled={busy}>
        Clear
      </Button>
      <Box sx={{ flex: 1 }} />
      {actions}
      {busy && progress && (
        <Box sx={{ width: '100%', mt: 1 }}>
          <Typography variant="caption" color="text.secondary">
            {progress.done} of {progress.total} processed
            {progress.failed > 0 && ` · ${progress.failed} failed`}
          </Typography>
          <LinearProgress
            variant="determinate"
            value={(progress.done / progress.total) * 100}
          />
        </Box>
      )}
    </Stack>
  );
}
